import React from 'react';
import { useConnectivity } from '../../contexts/ConnectivityContext';
import '../../css/common/ConnectivityBanner.css';

// オフライン時だけ表示する控えめな固定バナー。復帰は ConnectivityContext が
// 検知し、本コンポーネントは非表示に戻る（自動リフレッシュは Provider 側）。
function ConnectivityBanner() {
  const { offline } = useConnectivity();
  if (!offline) return null;

  return (
    <div className="connectivity-banner" role="status" aria-live="polite">
      <span className="connectivity-banner__dot" aria-hidden="true" />
      <span className="connectivity-banner__message">
        オフラインです。接続の回復を待っています…
      </span>
    </div>
  );
}

export default ConnectivityBanner;
